import { IMdfActivity } from 'partner360/features/mdfActivities/model/types'

import { parseMdfOutcome } from '../lib/mdfOutcome'

// Executed = status category is anything other than 'Planning' (null included).
export const isExecuted = (activity: IMdfActivity): boolean =>
  activity.statusCategory !== 'Planning'

export const hasOutcome = (activity: IMdfActivity): boolean =>
  parseMdfOutcome(activity.outcome).some((item) =>
    typeof item.value === 'string' ? Boolean(item.value.trim()) : item.value !== null
  )

export const isMissingOutcome = (activity: IMdfActivity): boolean =>
  isExecuted(activity) && !hasOutcome(activity)
